export default __webpack_public_path__ + "static/media/cloud-1-day.dddbeca8.svg";